import { ExternalToast, toast as sonner } from "sonner";
import { LoaderIcon, XIcon } from "lucide-react";

type Options = ExternalToast & {
  onAction?(): void;
};

const DEFAULT_DURATION = 4000;

export const toast = {
  success(message: string, options?: Options) {
    const id = sonner.success(message, {
      duration: DEFAULT_DURATION,
      icon: undefined,
      className: undefined,
      action: {
        label: <XIcon className="w-5 h-5" />,
        onClick: options?.onAction || (() => sonner.dismiss(id)),
      },
      ...options,
    });
    return id;
  },
  error(message: string, options?: Options) {
    const id = sonner.error(message, {
      duration: DEFAULT_DURATION,
      icon: undefined,
      className: undefined,
      action: {
        label: <XIcon className="w-5 h-5" />,
        onClick: options?.onAction || (() => sonner.dismiss(id)),
      },
      ...options,
    });
    return id;
  },
  info(message: string, options?: Options) {
    const id = sonner.info(message, {
      duration: DEFAULT_DURATION,
      icon: undefined,
      className: undefined,
      action: {
        label: <XIcon className="w-5 h-5" />,
        onClick: options?.onAction || (() => sonner.dismiss(id)),
      },
      ...options,
    });
    return id;
  },
  loading(message: string, options?: Options) {
    const id = sonner(message, {
      duration: DEFAULT_DURATION,
      icon: <LoaderIcon className="w-5 h-5" />,
      className: "bg-primary! text-primary-foreground!",
      action: {
        label: <XIcon className="w-5 h-5" />,
        onClick: options?.onAction || (() => sonner.dismiss(id)),
      },
      ...options,
    });
    return id;
  },
  dismiss(id: string | number) {
    sonner.dismiss(id);
  },
};
